import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormField, Heading, Select, Text } from 'grommet';
import AppConstants from '../helpers/AppConstants';

export const WEIGHT_OPTIONS = AppConstants.weightOptions;

const WEIGHT_FIELDS = [
    { name: 'majorsWeight', label: 'Ideal Major(s)' },
    { name: 'degreeTypeWeight', label: 'Degree Type' },
    { name: 'minimumGPAWeight', label: 'Minimum GPA' },
    { name: 'gradYearsWeight', label: 'Graduation Year' },
    { name: 'schoolsWeight', label: 'Specific School' },
    { name: 'locationsWeight', label: 'Location' },
    { name: 'jobFunctionsWeight', label: 'Interested Job Functions' },
    { name: 'industriesWeight', label: 'Interested Industries' },
    { name: 'technicalSkillsWeight', label: 'Technical Skills' },
    { name: 'experiencesWeight', label: 'Experiences' },
    { name: 'resumeReadyWeight', label: 'Resume Ready' },
    {
        name: 'welcomeCallCompletedWeight',
        label: 'Welcome Call Completed',
    },
];

const chunk = (arr, size) =>
    arr.reduce((rows, item, i) => {
        if (i % size === 0) rows.push([]);
        rows[rows.length - 1].push(item);
        return rows;
    }, []);

export const MatchWeightFields = ({ value, setValue }) => (
    <>
        <Heading level="3" margin={{ top: 'small', bottom: 'none' }}>
            Automated Match Weights
        </Heading>

        <Text>
            Set how important each field is to student data, adding up to a
            total score that determines who gets matched to this job by our
            automated system. &quot;Must Have&quot; means only students who
            exactly match that field will be considered.
        </Text>

        {chunk(WEIGHT_FIELDS, 3).map((row, i) => (
            <Box
                key={i}
                direction="row-responsive"
                gap="small"
                align="end">
                {row.map(({ name, label }) => (
                    <Box key={name} width="medium">
                        <FormField name={name} label={label}>
                            <Select
                                name={name}
                                options={WEIGHT_OPTIONS}
                                labelKey="label"
                                valueKey={{ key: 'value', reduce: true }}
                                placeholder="Select importance"
                                value={value[name]}
                                onChange={({ value: v }) =>
                                    setValue({ ...value, [name]: v })
                                }
                            />
                        </FormField>
                    </Box>
                ))}
            </Box>
        ))}
    </>
);

MatchWeightFields.propTypes = {
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired,
};
